import React from 'react';
import ChangeDishPositionState from './changeDishPositionState/ChangeDishPositionState';
import ChangeDishPosition from './components/ChangeDishPosition/ChangeDishPosition';

const ChangeDishPositionPage: React.FC = () => {
	return (
		<ChangeDishPositionState>
			<ChangeDishPosition />
		</ChangeDishPositionState>
	);
};

export default ChangeDishPositionPage;
